import DaylightIcon from './component'

export default DaylightIcon
